export const USER_ROLE = "SpecialtiesDashboardUser";
export const ADMIN_ROLE = "SpecialtiesDashboardAdmin";